




































import VueFramework from 'vue'
import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import {Channel, FileUploadList, GetChannelsResponse} from "../../repository/messagehub.dtos";
import ChannelApi from "../../repository/ChannelApi";
import CreateChannelModal from './CreateChannelModal.vue';
import {AxiosResponse} from "axios";
import * as channelRecord from "../../store/Channel/ChannelRecord";
@Component({
    components: {
        CreateChannelModal

    },
    name: 'ChannelComponent',
})
export default class ChannelComponent extends Vue{

    selectedChannel:any = ''
    channelApi: ChannelApi = new ChannelApi()
    isCreateChannelModalVisible: boolean = false
    isDeleteModalVisible: boolean = false;
    channels: Channel[] = []
    createChannelCommand(){
        this.isCreateChannelModalVisible = true
        this.$emit('onCreateChannelEvent')
    }
    getTopicsInSelectedChannel(item: any){
        channelRecord.selectedChannelChangedAction(this.$store, <Channel>item)
    }
    async created() {
        await this.getChannels();
    }
    get channelList(){
        return channelRecord.getChannels(this.$store)
    }
    @Watch('channelList')
    onPropertyChanged(value: Channel[], oldValue: Channel[]) {
        this.channels = value
    }
    async getChannels(){
        try {

            let channelData: GetChannelsResponse = await this.channelApi.getChannels()
            if (channelData.data.length >0)
            {
                channelRecord.initializeChannels(this.$store, <Array<Channel>> channelData.data)
            }
                //this.channels = channelData.data

        }
        catch (e) {
            console.log(e)
        }
    }
    cancelChannelCreate(){
        this.isCreateChannelModalVisible = false;
    }
    channelCreated(){
        this.isCreateChannelModalVisible = false
    }


    onChannelMenuCommandClick(item: any){
        if (item.id ==0){
            console.log('channel delete commmand')
        }
        else if (item.id ==1){
            this.isDeleteModalVisible = true;
        }
    }
}


